import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { IntroSection } from "./components/IntroSection";
import { BeforeAfter } from "./components/BeforeAfter";
import { Situations } from "./components/Situations";
import { Volumes } from "./components/Volumes";
import { Toolkit } from "./components/Toolkit";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { Author } from "./components/Author";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas" data-id="element-0" data-mp="23vuq4hqc94x9">
      <MetaPixel data-id="element-1" data-mp="23ti67z10skhk" />
      <Hero data-id="element-2" data-mp="3ik7e6ay3c1o0" />
      <main data-id="element-3" data-mp="3ikr0s4yore8d">
        <IntroSection data-id="element-4" data-mp="3iiwg8rrbto4t" />
        <BeforeAfter data-id="element-5" data-mp="3ijpcgysnsv8p" />
        <Situations data-id="element-6" data-mp="3ii4qvyobommz" />
        <Volumes data-id="element-7" data-mp="3mlatmwc87vop" />
        <Toolkit data-id="element-8" data-mp="3mkrgru1fnxhj" />
        <Bonuses data-id="element-9" data-mp="3mk83wrqn3zad" />
        <Offer data-id="element-10" data-mp="3mjpyp5m02aqb" />
        <Guarantee data-id="element-11" data-mp="3mj6jhwnqi0fz" />
        <Testimonials data-id="element-12" data-mp="3rcj2nr9n9f1c" />
        <Author data-id="element-13" data-mp="3rdas0kcnegj6" />
        <Faq data-id="element-14" data-mp="3rcsyvwla8ifh" />
        <FinalCta data-id="element-15" data-mp="3rd17vdeab3le" />
      </main>
      <Footer data-id="element-16" data-mp="5otf64sd496" />
      <FloatingCta data-id="element-17" data-mp="6htjo98ovic" />
      <PurchasePopup data-id="element-18" data-mp="4n4pyuukj8z" />
    </div>;
}